import React from 'react'
import Typography from 'material-ui/Typography'
import AppBar from 'material-ui/AppBar'
import Toolbar from 'material-ui/Toolbar'
import MenuIcon from 'material-ui-icons/Menu'
import IconButton from 'material-ui/IconButton'
import JssProvider from 'react-jss/lib/JssProvider'

import { BrowserRouter as Router } from 'react-router-dom'
import { createGenerateClassName } from 'material-ui/styles'

import './app.css'
import Drawer from './Drawer'
import Routes from './Routes'

const generateClassName = createGenerateClassName({
  productionPrefix: 'fd' // forth dashboard
})

const App = props =>
  <Router {...props.routerParams}>
    <JssProvider generateClassName={generateClassName}>
      <div>
        {!props.isVAS &&
        <div>
          <AppBar>
            <Toolbar>
              <IconButton
                color='inherit'
                onClick={props.onToggleDrawer}
                aria-label='Menu'
              >
                <MenuIcon />
              </IconButton>
              <Typography
                variant='title'
                color='inherit'
              >Forth Dashboard</Typography>
            </Toolbar>
          </AppBar>
          <Drawer {...props} />
        </div>
        }
        <Routes />
      </div>
    </JssProvider>
  </Router>

export default App



// WEBPACK FOOTER //
// ./src/app/App.js